module.exports = __webpack_public_path__ + "img/page2@2x.a3830a94.png";